<template lang="pug">

div.condition.multiselect-filter

  //- Select the operator (within the last x days, today, etc.)
    //- :items="operators"
  v-select.filter__operator(
    :items="operators"
    item-text="name"
    v-model="selectedOperator"
    @input="changedOperator"
    return-object
  )

  .filter__value(v-if="selectedOperator && selectedOperator.needValue")
    v-autocomplete.search(
      v-model="selectedValue"
      :items="allOptions"
      :search-input.sync="customChip"
      :menu-props="{ maxWidth: 'none'}"
      @keyup.enter="addChip"
      attach
      clearable
      deletable-chips
      open-on-clear
      small-chips
      multiple
      return-object
    )
      // Slot to show the hotness chips at selection chips.
      template(slot="selection" slot-scope="hotness")
        hotness(
          @input="hotness.parent.selectItem(hotness.item)"
          @close="closeChip(hotness)"
          :key="JSON.stringify(hotness.item)"
          :name="hotness.item"
          close
        )

      // Slot to override the select list item
      // to show a coloured hotness chip on each row
      template(slot="item" slot-scope="hotness")
        div.hotness-select-list-item
          v-list-tile-action
            v-icon.inactive(light) check_box_outline_blank
            v-icon.active(light) check_box
          v-list-tile-content
            v-list-tile-title
              hotness(
                :name="hotness.item"
                :maxLengthName="26"
              )

      template(
        slot="append-item"
        v-if="!chipAlreadyPresent"
      )
        v-list-tile.click-to-add(@click="addCustomChip")
          v-list-tile-content
            v-list-tile-title Click here to add '{{ customChip }}'


    v-tooltip(bottom)
      template(slot="activator")
        v-icon.help help
      span Can't find a search term in the list? Type it in yourself!

</template>

<script>
import Hotness from '../../../Contacts/components/Hotness';

export default {
  components: {
    Hotness,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Array,
      default: () => [],
    },
    operators: {
      type: Array,
      default: () => [], // operators,
    },
  },
  data() {
    return {
      /**
       * The operator from the list that's been selected
       * @type {Object}
       */
      selectedOperator: {},

      /**
       * The selected condition (operand and value)
       * @type {Object}
       */
      selectedValue: [],

      /**
       * The autocomplete plain string being searched
       */
      customChip: '',

      /**
       * Any and all custom chips that have been added
       */
      customChips: [],

    };
  },
  mounted() {

    this.selectedValue = this.value.value ? [...this.value.value] : [];
    this.addCustomChips(this.selectedValue);
    this.setSelectedOperator();

    if (this.noValueGiven()) {
      this.selectedValue = [];
    }

    this.$watch('selectedOperator', (operator, prev) => {
      this.emitSelected();
    });

    this.$watch('selectedValue', selectedValue => {
      this.emitSelected();
    });
  },
  watch: {
    selectedValue(next, prev) {

      if (prev.length === 0) return;

      if (next.length !== prev.length) {
        this.customChip = '';
      }
    },
  },
  computed: {
    allOptions() {
      return this.customChips.concat(this.options);
    },

    chipAlreadyPresent() {
      if (!this.customChip) return true;
      return this.isPresentInList(this.allOptions, this.customChip);
    },
  },

  methods: {

    /**
     * The operator has been changed; update/clear the value as necessary
     * @param  {} operator
     * @return {}
     */
    changedOperator(operator) {
      if (operator.needValue === false) {
        this.selectedValue = [];
      }
    },

    /**
     * Set the selected operator depending on what's been
     * passed in as selected
     */
    setSelectedOperator() {
      this.selectedOperator = this.operators.find(operator => {
        return operator.name === this.value.operator;
      });
    },

    /**
     * Check if any value is set
     * @return {Boolean}
     */
    noValueGiven() {
      return !this.selectedValue;
    },

    /**
     * Wrapper to emit condition operator & value
     */
    emitSelected() {
      this.$emit('input', {
        operator: this.selectedOperator.name,
        value: this.selectedValue,
      });
    },

    /**
     * Check if the chip is present in the list, in the same or a different
     * letter casing.
     *
     * @param {array} list - the list of strings to check
     * @param {string} chip - the needle
     */
    isPresentInList(list, chip) {
      const match = list.find(option => {
        return option.trim().toLowerCase() === chip.trim().toLowerCase();
      });

      return !!match;
    },

    /**
     * Check if the chip is present in the list, at least in part.
     *
     * We are looking to see if the chip as entered so far is in the list
     * in part.
     *
     * Like "Ta" will match "Tag"; so we don't want to add "Ta" as its own
     * item when it already matches others.
     *
     * @param {array} list - the list of strings to check
     * @param {string} chip - the needle
     */
    numberPartiallyContainedInList(list, chip) {
      const matches = list.filter(option => {
        return option
          .trim()
          .toLowerCase()
          .includes(chip.toLowerCase());
      });

      return matches.length;
    },

    /**
     * On mount, some custom chips may be present in the selected chips.
     * If not already present in the list, we add them to the list of
     * searchable chips.
     *
     * @param {array} chips incoming to the component on mount
     */
    addCustomChips(incomingChips) {

      if (!incomingChips || !Array.isArray(incomingChips)) return;

      incomingChips.forEach(chip => {
        if (!this.isPresentInList(this.options, chip)) {
          this.customChips.push(chip.trim());
        }
      });
    },

    /**
     * Returns the correct string if there is no contact that matches
     * the given search string.
     */
    displayNone() {
      const minCharacters = 2;
      if (this.customChip && this.customChip.length >= minCharacters) {
        return `Press enter to add '${this.customChip.trim()}'`;
      }
      return `Please enter at least ${minCharacters} letters`;
    },

    /**
     * Add the custom tag
     */
    addCustomChip() {
      if (!this.isPresentInList(this.allOptions, this.customChip)) {
        this.customChips.push(this.customChip.trim());
        this.selectedValue.push(this.customChip.trim());
        this.customChip = '';
      }
    },

    /**
     * When enter is pressed, check if there's a chip and add it to the
     * custom list if it's not already there in some form.
     *
     * If this chip is not partially contained in the existing lists,
     * add it.
     *
     * If this chip is partially contained in one other, that item will
     * be selected in the drop-down and will be added automatically by
     * vuetify anyway. We simply clear the input.
     *
     * If there are 2+ matches, we do nothing. Don't clear, don't add new?
     *
     * One repercussion of this approach is that we can't add a tag
     * that is a substring of an already existing string.
     */
    addChip() {

      if (!this.customChip || !this.customChip.trim()) {
        return;
      }

      if (this.numberPartiallyContainedInList(this.allOptions, this.customChip) === 0) {
        this.addCustomChip();
      }

      // TODO CS - Cannot currently add a token that is a partial match of
      // an existing token
      if (this.numberPartiallyContainedInList(this.allOptions, this.customChip) === 1) {
        this.customChip = '';
      }
    },
    /**
     * Remove an element selected from the autocomplete control
    */
    closeChip(item) {
      this.selectedValue.splice(item.index, 1);
    },
  },
};
</script>
<style lang="sass" type="text/sass">

// Turn chip clicking off so the user can click anywhere in the type-ahead
// to open the dropdown.
.multiselect-filter

  .filter__value
    display: flex
    width: 100%
    align-items: center
    .v-select.v-select--chips .v-select__selections
      min-height: 32px
      width: 32px
      flex-wrap: wrap
    .v-tooltip
      flex: 0 0 40px
      text-align: center
      margin-top: 10px
    .v-input__append-inner
      margin-top: 2px

    .v-list__tile

      &--active
        .hotness-select-list-item
          .v-list__tile__action
            .v-icon.active.theme--light
              display: inline-block
            .v-icon.inactive.theme--light
              display: none

      .hotness-select-list-item
        color: white
        display: flex

        .v-list__tile__action
          .v-icon.active
            display: none
          .v-icon.inactive
            display: inline-block

          .theme--light.v-icon
            color: var(--v-primary-base)
            width: 40px;
            padding-top: 5px;

        .v-list__tile__content
          padding-top: 13px;
          .hotness .v-chip__content
            cursor: pointer
</style>
